import { OnInit, ChangeDetectorRef } from '@angular/core';
import { AppLoadingEventsEmitter } from '../../../shared/events/loading.events';
import { Constants } from '../../../shared/config/constants.config';
import { Router } from '@angular/router';
import { GlobalCategoryViewModel } from '../../../meals/components/viewModels/category.viewModel';
import { UsersService } from '../../../shared/services/users.service';
import { forkJoin } from 'rxjs';
import { ProductsService } from '../../../shared/services/products.service';
var UserPreferredGlobalCategoriesComponent = /** @class */ (function () {
    function UserPreferredGlobalCategoriesComponent(changeDetectorRef, usersService, appIsLoadingEventsEmitter, constants, productsService, router) {
        this.changeDetectorRef = changeDetectorRef;
        this.usersService = usersService;
        this.appIsLoadingEventsEmitter = appIsLoadingEventsEmitter;
        this.constants = constants;
        this.productsService = productsService;
        this.router = router;
        this.selectedPreferredCategories = [];
        this.globalCategories = [];
    }
    UserPreferredGlobalCategoriesComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);
        forkJoin(this.productsService.getGlobalCategories(), this.usersService.getUserPreferredGlobalCategories()).subscribe(function (_a) {
            var globalCategories = _a[0], userPreferredGlobalCategories = _a[1];
            _this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
            _this.globalCategories = globalCategories;
            userPreferredGlobalCategories.map(function (globalCategory) {
                _this.addCategoryToPreferred(globalCategory.global_category);
            });
            _this.changeDetectorRef.detectChanges();
        });
    };
    UserPreferredGlobalCategoriesComponent.prototype.addCategoryToPreferred = function (category) {
        if (this.isCategoryPreferred(category)) {
            this.selectedPreferredCategories.splice(this.selectedPreferredCategories.indexOf(category.id), 1);
        }
        else {
            this.selectedPreferredCategories.push(category.id);
        }
        this.changeDetectorRef.markForCheck();
    };
    UserPreferredGlobalCategoriesComponent.prototype.isCategoryPreferred = function (category) {
        for (var _i = 0, _a = this.selectedPreferredCategories; _i < _a.length; _i++) {
            var categoryId = _a[_i];
            // @ts-ignore
            // tslint:disable-next-line:radix
            if (categoryId === parseInt(category.id)) {
                return true;
            }
        }
        return false;
    };
    UserPreferredGlobalCategoriesComponent.prototype.updateUserPreferredCategories = function () {
        var _this = this;
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);
        this.usersService.setUserPreferredCategories(this.selectedPreferredCategories).subscribe(function () {
            _this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
        }, function () {
            _this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
        });
    };
    return UserPreferredGlobalCategoriesComponent;
}());
export { UserPreferredGlobalCategoriesComponent };
